import React from 'react';
import { DocumentsButton } from './DocumentsButton';
import { DocumentsPanel } from './DocumentsPanel';

const IFRAME_CONTAINER_STYLE = { position: 'relative' };

const IFRAME_FULLSCREEN_STYLE = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  zIndex: 9999,
  backgroundColor: '#fff',
  padding: 0,
  margin: 0,
};

const BUTTONS_WRAPPER_STYLE = {
  position: 'absolute',
  top: '1rem',
  right: '1rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.5rem',
  zIndex: 10,
};

const FULLSCREEN_BUTTON_STYLE = {
  padding: '0.75rem 1.5rem',
  fontSize: '1rem',
  cursor: 'pointer',
};

const DROPDOWN_PANEL_STYLE = {
  position: 'absolute',
  top: '4.5rem',
  right: '1rem',
  zIndex: 10,
  backgroundColor: 'white',
  border: '2px solid #FD99C5',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  padding: '1rem',
  maxWidth: '350px',
  maxHeight: '70vh',
  overflowY: 'auto',
};

/**
 * Play Game tab: iframe + fullscreen button + documents dropdown.
 */
export function PlayGameTab({
  iframeLink,
  title,
  queryString,
  isFullscreen,
  onToggleFullscreen,
  showDocumentsButton,
  showDocumentsPanel,
  onToggleDocumentsPanel,
  cheatSheetDocuments,
  workSheetDocuments,
  isSubscribed,
  isLoggedIn,
  subscriptionPrice,
  miniCart,
  ownedProducts,
  onAddToCart,
  onSubscribe,
}) {
  const hasDocuments =
    (cheatSheetDocuments?.length ?? 0) > 0 ||
    (workSheetDocuments?.length ?? 0) > 0;

  const params = queryString?.startsWith('?') ? queryString.slice(1) : queryString || '';
  const iframeSrc = params
    ? `${iframeLink}${iframeLink.includes('?') ? '&' : '?'}${params}`
    : iframeLink;
  
      // ? `${http://localhost:5173/#/cube-3d}${iframeLink.includes('?') ? '&' : '?'}${params}`


  return (
    <div className="container">
      <div
        className="interactive-iframe-container"
        style={isFullscreen ? IFRAME_FULLSCREEN_STYLE : IFRAME_CONTAINER_STYLE}
      >
        <div className="interactive-learning-buttons" style={BUTTONS_WRAPPER_STYLE}>
          {hasDocuments && (
            <DocumentsButton
              cheatSheetCount={cheatSheetDocuments?.length ?? 0}
              workSheetCount={workSheetDocuments?.length ?? 0}
              onClick={onToggleDocumentsPanel}
              showPanel={showDocumentsPanel}
              visible={showDocumentsButton}
            />
          )}
          <button
            type="button"
            className="button"
            onClick={onToggleFullscreen}
            style={FULLSCREEN_BUTTON_STYLE}
          >
            {isFullscreen ? '✕ Exit Fullscreen' : 'Enter Fullscreen'}
          </button>
        </div>

        {showDocumentsPanel && hasDocuments && (
          <div
            id="documents-dropdown-panel"
            style={DROPDOWN_PANEL_STYLE}
            className="documents-panel-desktop"
          >
            {cheatSheetDocuments?.length > 0 && (
              <DocumentsPanel
                documents={cheatSheetDocuments}
                type="cheatSheet"
                isSubscribed={isSubscribed}
                isLoggedIn={isLoggedIn}
                subscriptionPrice={subscriptionPrice}
                miniCart={miniCart}
                ownedProducts={ownedProducts}
                onAddToCart={onAddToCart}
                onSubscribe={onSubscribe}
              />
            )}
            {workSheetDocuments?.length > 0 && (
              <div
                style={{
                  marginTop: (cheatSheetDocuments?.length ?? 0) > 0 ? '1.5rem' : 0,
                }}
              >
                <DocumentsPanel
                  documents={workSheetDocuments}
                  type="worksheets"
                  isSubscribed={isSubscribed}
                  isLoggedIn={isLoggedIn}
                  subscriptionPrice={subscriptionPrice}
                  miniCart={miniCart}
                  ownedProducts={ownedProducts}
                  onAddToCart={onAddToCart}
                  onSubscribe={onSubscribe}
                />
              </div>
            )}
          </div>
        )}

        <iframe
          title={title}
          src={iframeSrc}
          frameBorder="0"
          width="100%"
          height={isFullscreen ? '100%' : '750px'}
          style={isFullscreen ? { border: 'none' } : {}}
        />
      </div>
    </div>
  );
}
